export const getCatalogAuth = async (initDataRaw: string, userId: number) => {
  const response = await fetch(
    `${import.meta.env.VITE_CORE_API_URL}/auth/user-tma`,
    {
      body: JSON.stringify({
        applicationId: import.meta.env.VITE_CORE_API_APP_ID,
        dataTma: initDataRaw,
      }),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "POST",
    }
  )

  const { data } = await response.json()

  if (response.ok) {
    const token = data?.token
    if (token) return token
    else return Promise.reject(new Error(`Failed to authorize catalog`))
  }
}
